import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { createDetailsListColumnFactory, detailsListColumnWidths as cw, TooltipHost } from "@advosys/component-react";
import { stringOverflow } from "@advosys/component-react-utils";
import { TooltipOverflowMode } from "@fluentui/react";
import { formatMatterTypeDisplayValue, formatUserDisplayValue } from "../../utils";
import { useT } from "./dynamic-invoice-page-i18n";
import { ApproverFlowSteps } from "./components/approver-flow-steps/approver-flow-steps";
const cf = createDetailsListColumnFactory();
export const useDynamicInvoicePageColumns = () => {
    const { t } = useT();
    const columns = useMemo(() => [
        cf("matterId", t.columnMatterId, cw.shortText, item => item.matterId),
        cf("recipientName", t.columnRecipientName, cw.mediumText, item => item.recipientName),
        cf("contactName", t.columnContactName, cw.mediumText, item => item.contactName),
        cf("invoiceRegarding", t.columnInvoiceRegarding, cw.mediumText, item => item.invoiceRegarding),
        cf("feeStatement", t.columnFeeStatement, cw.mediumText, item => stringOverflow(item.feeStatement, 500)),
        cf("fee", t.columnFee, cw.decimal, item => item.fee, {
            format: "b2",
            justifyContent: "flex-end"
        }),
        cf("billableAmount", t.columnBillableAmount, cw.decimal, item => item.billableAmount, {
            format: "b2",
            justifyContent: "flex-end"
        }),
        cf("totalMatterLedgerEntries", t.columnnTotalMatterLedgerEntries, cw.decimal, item => item.totalMatterLedgerEntries, {
            format: "b2",
            justifyContent: "flex-end"
        }),
        cf("approvalFlowSteps", t.columnApproverFlow, cw.mediumText, item => {
            const approverFlowSteps = _jsx(ApproverFlowSteps, { steps: item.approvalFlowSteps });
            return (_jsx(TooltipHost, { content: approverFlowSteps, overflowMode: TooltipOverflowMode.Parent, children: approverFlowSteps }));
        }),
        cf("currentApproverFlowComment", t.columnCurrentApproverFlowComment, cw.shortText, item => item.currentApproverFlowComment),
        cf("liableLawyer", t.columnLiableLawyer, cw.mediumText, item => formatUserDisplayValue(item.liableLawyer), {
            filter: { filterKind: "selectvalues", handling: { getItemFilterValue: item => formatUserDisplayValue(item.liableLawyer) } }
        }),
        cf("clientLeadLawyer", t.columnClientLeadLawyer, cw.mediumText, item => formatUserDisplayValue(item.clientLeadLawyer), {
            filter: { filterKind: "selectvalues", handling: { getItemFilterValue: item => formatUserDisplayValue(item.clientLeadLawyer) } }
        }),
        cf("lawyer", t.columnLawyer, cw.mediumText, item => formatUserDisplayValue(item.lawyer), {
            filter: { filterKind: "selectvalues", handling: { getItemFilterValue: item => formatUserDisplayValue(item.lawyer) } }
        }),
        cf("attorney", t.columnAttorney, cw.mediumText, item => formatUserDisplayValue(item.attorney), {
            filter: { filterKind: "selectvalues", handling: { getItemFilterValue: item => formatUserDisplayValue(item.attorney) } }
        }),
        cf("matterType", t.columnMatterType, cw.mediumText, item => formatMatterTypeDisplayValue(item.matterType), {
            filter: { filterKind: "selectvalues", handling: { getItemFilterValue: item => formatMatterTypeDisplayValue(item.matterType) } }
        })
    ], [t]);
    return { columns };
};
